module.exports = __webpack_public_path__ + "static/img_0205_dpp_optimized-411dff9f030881ff18071a42cfb3d6b9.jpg";